import { Button } from "@/components/core/buttons/button";
import DataTable from "@/components/core/data-table";
import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { ScrollArea } from "@/components/core/scroller";
import { caseActivityLogsQueryOptions } from "@/features/case-record/api/queries/case-activity-log-query";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { formatDate } from "date-fns/format";
import { useForm } from "react-hook-form";
import { useActivityViewRequestMutation } from "../api/queries/acitivities-query";

export default function CaseActivityViewRequestModal({ activity }: { activity: any }) {
	const modal = useModal();

	const navigate = useNavigate();
	const { closeModal } = useModalControl();

	const form = useForm({
		defaultValues: {},
	});

	const columns: ColumnDef<CaseRecord>[] = [
		{
			id: "activity",
			label: "Requested by",
			cellClassName: "min-w-[40%] max-w-[40%] w-[40%]",
			cell: ({ data, onClick }) => (
				<span>
					{data.causer?.full_name} {data.description} {data.module}{" "}
				</span>
			),
		},
		{
			id: "status",
			label: "Status",
			cellClassName: "",
			cell: ({ data }) => <span>{data.status}</span>,
		},
		{
			id: "created_at",
			label: "Date",
			cellClassName: "min-w-[120px] max-w-[120px] w-[120px]",
			cell: ({ data }) => formatDate(data.created_at, "PPp"),
		},
	];

	const caseActivityViewRequestMutation = useActivityViewRequestMutation();

	return (
		<Form {...form}>
			<form className="w-full max-h-[540px]">
				<ScrollArea className="flex grow h-[calc(100svh -220px)]">
					<div className="flex flex-col w-full rounded-md border border-border/50 max-h-[540px] scroll">
						{/* <DataTable
							className="border-collapse"
							data={activity.view_request}
							columns={columns}
							stickyHead={false}
							stickyCol={false}
							showBorder={true}
							compact={true}
							showToolbar={false}
						/> */}
						<table>
							<thead>
								<tr className="border-b-2 border-border/50">
									<th className=" text-left text-foreground-dark p-3">Requested By</th>
									<th className=" text-left text-foreground-dark p-3">Status</th>
									<th className=" text-right text-foreground-dark p-3">Date</th>
									<th className=" text-right text-foreground-dark p-3">Action</th>
								</tr>
							</thead>
							<tbody>
								{activity.view_request?.map((log, index) => (
									<tr key={index} className="border-b border-border/50 last:border-b-0">
										<td width={"40%"} className="px-3 py-2">
											{" "}
											{log.requested_by_user?.full_name}
										</td>
										<td className="px-3 py-2">{log.status}</td>
										<td width={"200px"} className="px-3">
											{" "}
											{formatDate(log.created_at, "PPp")}
										</td>
										<td className="text-right px-3 py-2">
											{log.status === "pending" && (
												<Button
													type="button"
													className="text-blue-500 hover:text-blue-700"
													variant={"green"}
													size={"sm"}
													onClick={() => {
														modal.openModal({
															title: "Grant View Request",
															description: "You are granting this activity view request. Please confirm.",
															type: "confirm",
															variant: "green",
															onConfirm: async () => {
																await caseActivityViewRequestMutation.mutateAsync(log.id);
																closeModal();
															},
														});
													}}
												>
													Grant
												</Button>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</ScrollArea>
			</form>
		</Form>
	);
}
